import { useState } from "react";
import { Globe, ThumbsUp, MessageSquare, Repeat2, Send, AlertTriangle, CheckCircle2 } from "lucide-react";

export const MAX_CHARS = 210;
export const MAX_LINES = 3;

// Coupure « … voir plus » : 3 lignes ou 210 caractères, au premier des deux atteint.
export function seeMoreCut(text) {
  const lines = text.split("\n");
  const lineEnd = lines.length > MAX_LINES ? lines.slice(0, MAX_LINES).join("\n").length : text.length;
  let cut = Math.min(lineEnd, MAX_CHARS);
  if (cut >= text.length) return { visible: text, cut: false };
  if (cut === MAX_CHARS && cut < lineEnd) {
    const head = text.slice(0, cut + 1);
    const sp = Math.max(head.lastIndexOf(" "), head.lastIndexOf("\n"), head.lastIndexOf("\u00a0"));
    if (sp > 0) cut = sp;
  }
  return { visible: text.slice(0, cut).trimEnd(), cut: true, parLignes: lineEnd <= MAX_CHARS };
}

export const LinkedInPreview = ({ texte, image, pageNom, pageLogo, connectee }) => {
  const [open, setOpen] = useState(false);
  const { visible, cut, parLignes } = seeMoreCut(texte);
  const accroche = texte.split("\n\n")[0].trimEnd();
  const accrocheOk = accroche.length <= visible.length;
  return (
    <div className="space-y-3" data-testid="linkedin-preview">
      <div className={`flex items-start gap-2 rounded-sm px-3 py-2 text-xs ${accrocheOk ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`} data-testid="linkedin-accroche-check">
        {accrocheOk ? <CheckCircle2 className="h-4 w-4 shrink-0" /> : <AlertTriangle className="h-4 w-4 shrink-0" />}
        <span>{accrocheOk ? "Accroche entièrement visible avant « … voir plus »." : `Accroche coupée par « … voir plus » : ${accroche.length} caractères, ${visible.length} visibles avant la coupure.`}
          {cut && <span className="block opacity-80">Coupure {parLignes ? "après 3 lignes" : "à 210 caractères"}. Aperçu seulement, le texte n'est pas modifié.</span>}</span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg shadow-sm max-w-[555px] mx-auto font-sans text-[14px] text-[#191919]">
        <div className="flex items-center gap-2 px-4 pt-3">
          <div className="h-12 w-12 shrink-0 bg-white border border-slate-200 p-[5px] box-border flex items-center justify-center" data-testid="linkedin-page-avatar">
            <img src={pageLogo || "/apollo-logo.png"} alt="Logo de la page" data-testid="linkedin-page-logo" className="w-full h-full object-contain" />
          </div>
          <div className="leading-tight">
            <p className="font-semibold" data-testid="linkedin-page-name">{pageNom}</p>
            <p className="text-xs text-slate-500" data-testid="linkedin-page-connection">{connectee ? "Page LinkedIn connectée" : "Page LinkedIn pas encore associée"}</p>
            <p className="text-xs text-slate-500 inline-flex items-center gap-1">Maintenant · <Globe className="h-3 w-3" /></p>
          </div>
        </div>
        <div className="px-4 py-2 whitespace-pre-wrap leading-[1.43]" data-testid="linkedin-text">
          {open || !cut ? texte : visible}
          {cut && !open && <>… <button type="button" onClick={() => setOpen(true)} className="text-slate-500 hover:text-[#0a66c2] hover:underline" data-testid="linkedin-see-more">voir plus</button></>}
          {cut && open && <button type="button" onClick={() => setOpen(false)} className="block mt-1 text-slate-500 hover:underline text-xs" data-testid="linkedin-see-less">voir moins</button>}
        </div>
        {image && <img src={image} alt="Visuel du post" className="w-full" data-testid="linkedin-image" />}
        <div className="grid grid-cols-4 border-t border-slate-200 text-slate-600 text-xs font-semibold">
          {[[ThumbsUp, "J'aime"], [MessageSquare, "Commenter"], [Repeat2, "Republier"], [Send, "Envoyer"]].map(([I, l]) => (
            <span key={l} className="flex items-center justify-center gap-1.5 py-3"><I className="h-4 w-4" />{l}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LinkedInPreview;
